import { useTheme } from '@fluentui/react';
import { FC, useMemo } from 'react';
import StyledDonutChart from './StyledDonutChart';

interface IProps {
    text: string;
    color: string;
    fullness?: number;
}

const ClockDisplay: FC<IProps> = ({ text, color, fullness = 1 }) => {
    const { palette } = useTheme();

    const data = useMemo(
        () => {
            const filledCount = Math.floor(fullness / (1 / 12));
            return {
                chartData: [
                    ...Array(filledCount).fill({ legend: '', data: 1, color }),
                    ...Array(12 - filledCount).fill({ legend: '', data: 1, color: palette.neutralQuaternary }),
                ],
            };
        },
        [color, fullness, palette.neutralQuaternary],
    );

    return (
        <StyledDonutChart
            text={text}
            data={data}
            innerRadius={33}
            hideTooltip={true}
            hideLegend={true}
            height={95}
            width={95}
        />
    );
};

export default ClockDisplay;